"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es7.array.includes");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _exportCostSlipUpload = require("@/api/exportCostSlipUpload/exportCostSlipUpload");
var _booking = require("@/api/bookSpace/booking");
var _utils = require("@/utils");
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: "uploadInvoiceDlg",
  props: {
    formDialog: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    companyName: {
      type: String,
      default: ""
    },
    pol: {
      type: String,
      default: ""
    },
    idBlNos: {
      type: String,
      default: ""
    },
    invoiceData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      invoiceInfoHistory: JSON.parse(localStorage.getItem('invoiceInfoHistory')) || [],
      loading: null,
      acceptList: '.pdf, .jpg, .png, .bmp, .tiff',
      amountAllRMBFileList: [],
      amountAllUSDFileList: [],
      amountAllHKDFileList: [],
      amountRMBFileList: [],
      amountUSDFileList: [],
      amountHKDFileList: [],
      amountOCNYFileList: [],
      amountOUSDFileList: [],
      invoiceWayList: [],
      form: {
        paymentNo: "",
        paymentWay: "00",
        amountRMB: "",
        amountRMBFileId: "",
        amountUSD: "",
        amountUSDFileId: "",
        amountHKD: "",
        amountHKDFileId: "",
        amountAllRMB: "",
        amountAllRMBFileId: "",
        amountAllUSD: "",
        amountAllUSDFileId: "",
        amountAllHKD: "",
        amountAllHKDFileId: "",
        amountOCNY: "",
        amountOCNYFileId: "",
        amountOUSD: "",
        amountOUSDFileId: "",
        invoiceWay: "02",
        taxpayerIdentificationNumber: "",
        address: "",
        phone: "",
        bank: "",
        account: "",
        consignee: "",
        soaNo: "",
        invoiceNumber: "",
        bankUsd: "",
        accountUsd: "",
        remark: "",
        bankSlipBlNoAndFeeId: ""
      },
      rules: {
        taxpayerIdentificationNumber: [{
          required: true,
          message: this.$t('exportCostSlipUpload.taxpayerIdentificationNumberNotNull'),
          trigger: 'blur'
        }],
        address: [{
          required: true,
          message: this.$t('exportCostSlipUpload.addressNotNull'),
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          message: this.$t('exportCostSlipUpload.phoneNotNull'),
          trigger: 'blur'
        }],
        bank: [{
          required: true,
          message: this.$t('exportCostSlipUpload.bankNotNull'),
          trigger: 'blur'
        }],
        account: [{
          required: true,
          message: this.$t('exportCostSlipUpload.accountNotNull'),
          trigger: 'blur'
        }],
        consignee: [{
          required: true,
          message: this.$t('exportCostSlipUpload.consigneeNotNull'),
          trigger: 'blur'
        }, {
          type: 'email',
          message: this.$t('exportCostSlipUpload.invalidEmail'),
          trigger: 'blur'
        }, {
          pattern: /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/,
          message: this.$t('exportCostSlipUpload.invalidEmail'),
          trigger: 'blur'
        }]
      }
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])),
  mounted: function mounted() {
    var _this = this;
    this.$dictionary.get(['DOC_INVOICE_WAY'], true).then(function (res) {
      res = JSON.parse(JSON.stringify(res));
      _this.invoiceWayList = res.DOC_INVOICE_WAY ? res.DOC_INVOICE_WAY : [];
    });
  },
  methods: {
    uploadFile: function uploadFile(item, type) {
      var _this2 = this;
      var validate = true;
      if (item.file.size > 10 * 1024 * 1024) {
        this.$message.warning(this.$t('blExchangeAppointment.fileSize'));
        validate = false;
      }
      var validTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/bmp', 'image/tiff'];
      if (!validTypes.includes(item.file.type)) {
        this.$message.warning(this.$t('blExchangeAppointment.fileFormat'));
        validate = false;
      }
      if (item.file.name.length > 40) {
        this.$message.warning(this.$t('blExchangeAppointment.attachmentFileLength'));
        validate = false;
      }
      if (!validate) {
        if (type === 'RMB') {
          this.amountRMBFileList = [];
        } else if (type === 'USD') {
          this.amountUSDFileList = [];
        } else if (type === 'HKD') {
          this.amountHKDFileList = [];
        } else if (type === 'OCNY') {
          this.amountOCNYFileList = [];
        } else if (type === 'OUSD') {
          this.amountOUSDFileList = [];
        } else if (type === 'AllRMB') {
          this.amountAllRMBFileList = [];
        } else if (type === 'AllUSD') {
          this.amountAllUSDFileList = [];
        } else if (type === 'AllHKD') {
          this.amountAllHKDFileList = [];
        }
        return;
      }
      var formDatas = new FormData();
      formDatas.append("file", item.file);
      formDatas.append("bucket", 'commerce');
      this.loading = (0, _utils.load)();
      (0, _booking.setUploadFile)(formDatas).then(function (res) {
        if (res.code) {
          if (type === 'RMB') {
            _this2.form.amountRMBFileId = res.fileId;
          } else if (type === 'USD') {
            _this2.form.amountUSDFileId = res.fileId;
          } else if (type === 'HKD') {
            _this2.form.amountHKDFileId = res.fileId;
          } else if (type === 'OCNY') {
            _this2.form.amountOCNYFileId = res.fileId;
          } else if (type === 'OUSD') {
            _this2.form.amountOUSDFileId = res.fileId;
          } else if (type === 'AllRMB') {
            _this2.form.amountAllRMBFileId = res.fileId;
          } else if (type === 'AllUSD') {
            _this2.form.amountAllUSDFileId = res.fileId;
          } else if (type === 'AllHKD') {
            _this2.form.amountAllHKDFileId = res.fileId;
          }
          _this2.$message.success(_this2.$t("home.uploadTitleSuccess"));
        } else {
          _this2.$message.warning(res.errorMessages[0]);
        }
      }).finally(function () {
        _this2.loading.close();
      });
    },
    handleRemove: function handleRemove(file, type) {
      var _this3 = this;
      this.loading = (0, _utils.load)();
      var fileId;
      if (type === 'RMB') {
        fileId = this.form.amountRMBFileId;
      } else if (type === 'USD') {
        fileId = this.form.amountUSDFileId;
      } else if (type === 'HKD') {
        fileId = this.form.amountHKDFileId;
      } else if (type === 'OCNY') {
        fileId = this.form.amountOCNYFileId;
      } else if (type === 'OUSD') {
        fileId = this.form.amountOUSDFileId;
      } else if (type === 'AllRMB') {
        fileId = this.form.amountAllRMBFileId;
      } else if (type === 'AllUSD') {
        fileId = this.form.amountAllUSDFileId;
      } else if (type === 'AllHKD') {
        fileId = this.form.amountAllHKDFileId;
      }
      (0, _booking.deleteByFileId)(fileId).then(function (res) {
        if (res) {
          if (type === 'RMB') {
            _this3.form.amountRMBFileId = '';
          } else if (type === 'USD') {
            _this3.form.amountUSDFileId = '';
          } else if (type === 'HKD') {
            _this3.form.amountHKDFileId = '';
          } else if (type === 'OCNY') {
            _this3.form.amountOCNYFileId = '';
          } else if (type === 'OUSD') {
            _this3.form.amountOUSDFileId = '';
          } else if (type === 'AllRMB') {
            _this3.form.amountAllRMBFileId = '';
          } else if (type === 'AllUSD') {
            _this3.form.amountAllUSDFileId = '';
          } else if (type === 'AllHKD') {
            _this3.form.amountAllHKDFileId = '';
          }
          _this3.$message.success(_this3.$t('roleCertificationApplication.deleteMessage'));
        } else {
          _this3.$message.warning(res.errorMessages[0]);
        }
      }).finally(function () {
        _this3.loading.close();
      });
    },
    addInvoiceInfoHistory: function addInvoiceInfoHistory() {
      var obj = {
        taxpayerIdentificationNumber: this.form.taxpayerIdentificationNumber,
        address: this.form.address,
        phone: this.form.phone,
        bank: this.form.bank,
        account: this.form.account,
        consignee: this.form.consignee
      };
      this.invoiceInfoHistory = obj;
      localStorage.setItem('invoiceInfoHistory', JSON.stringify(this.invoiceInfoHistory));
    },
    handleSave: function handleSave() {
      var _this4 = this;
      this.$refs['form'].validate(function (valid) {
        if (valid) {
          _this4.addInvoiceInfoHistory();
          _this4.loading = (0, _utils.load)();
          (0, _exportCostSlipUpload.saveBankInvoiceSHK)(_this4.form).then(function (res) {
            if (res.success) {
              _this4.$message.success(_this4.$t('exportCostSlipUpload.saveSuccessfully'));
              _this4.closed();
            } else {
              _this4.$message.error(res.errorMessages[0]);
            }
          }).finally(function () {
            _this4.loading.close();
          });
        }
      });
    },
    beforeRemove: function beforeRemove(file) {
      return this.$confirm("\u786E\u5B9A\u79FB\u9664 ".concat(file.name, "\uFF1F"));
    },
    opened: function opened() {
      var _this5 = this;
      this.$nextTick(function () {
        _this5.form.paymentNo = _this5.companyName;
        _this5.form.pol = _this5.pol;
        _this5.form.amountUSD = _this5.formDialog.amountUSD;
        _this5.form.amountRMB = _this5.formDialog.amountRMB;
        _this5.form.amountHKD = _this5.formDialog.amountHKD;
        _this5.form.amountAllHKD = _this5.formDialog.amountAllHKD;
        _this5.form.amountAllUSD = _this5.formDialog.amountAllUSD;
        _this5.form.amountAllRMB = _this5.formDialog.amountAllRMB;
        _this5.form.amountOCNY = _this5.formDialog.amountRMB;
        _this5.form.amountOUSD = _this5.formDialog.amountUSD;
        _this5.form.bankSlipBlNoAndFeeId = _this5.idBlNos;
        if (_this5.invoiceData.saveFlag == '0') {
          _this5.form.invoiceNo = _this5.invoiceData.invoiceNo || _this5.form.invoiceNo;
          _this5.form.invoiceWay = _this5.invoiceData.invoiceWay || _this5.form.invoiceWay;
          _this5.form.consignee = _this5.invoiceData.consignee || _this5.form.consignee;
          _this5.form.phone = _this5.invoiceData.phone || _this5.form.phone;
          _this5.form.address = _this5.invoiceData.address || _this5.form.address;
          _this5.form.taxpayerIdentificationNumber = _this5.invoiceData.taxpayerIdentificationNumber || _this5.form.taxpayerIdentificationNumber;
          _this5.form.bank = _this5.invoiceData.bank || _this5.form.bank;
          _this5.form.account = _this5.invoiceData.account || _this5.form.account;
          _this5.form.soaNo = _this5.invoiceData.soaNo || _this5.form.soaNo;
          _this5.form.invoiceNumber = _this5.invoiceData.invoiceNumber || _this5.form.invoiceNumber;
          _this5.form.bankUsd = _this5.invoiceData.bankUsd || _this5.form.bankUsd;
          _this5.form.accountUsd = _this5.invoiceData.accountUsd || _this5.form.accountUsd;
        }
        if (_this5.formDialog.amountAllRMB == null || _this5.formDialog.amountAllRMB == "0" || _this5.formDialog.amountAllUSD == null || _this5.formDialog.amountAllUSD == "0" || _this5.pol != 'CNNSA' && _this5.pol != 'CNYPG' && (_this5.formDialog.amountAllHKD == null || _this5.formDialog.amountAllHKD == "0")) {
          _this5.$alert(_this5.$t('exportCostSlipUpload.noRate'), {
            confirmButtonText: _this5.$t('exportCostSlipUpload.confirm')
          });
        }
        if (!(0, _validate.validateNull)(_this5.invoiceInfoHistory)) {
          _this5.form.taxpayerIdentificationNumber = _this5.invoiceInfoHistory.taxpayerIdentificationNumber;
          _this5.form.address = _this5.invoiceInfoHistory.address;
          _this5.form.phone = _this5.invoiceInfoHistory.phone;
          _this5.form.bank = _this5.invoiceInfoHistory.bank;
          _this5.form.account = _this5.invoiceInfoHistory.account;
          _this5.form.consignee = _this5.invoiceInfoHistory.consignee;
        }
      });
    },
    closed: function closed() {
      this.amountAllRMBFileList = [];
      this.amountAllUSDFileList = [];
      this.amountAllHKDFileList = [];
      this.amountRMBFileList = [];
      this.amountUSDFileList = [];
      this.amountHKDFileList = [];
      this.amountOCNYFileList = [];
      this.amountOUSDFileList = [];
      this.$emit('handleCloseUploadInvoiceDlg');
    }
  }
};